import styled from 'styled-components';

export const RouteBadgeWrapper = styled.div`
  border-bottom: ${props => (props.underline ? 2 : 0)}px solid
    ${props => props.theme.routeDetailBadgeBorder};
  border-radius: 50%;
`;

export const RouteBadge = styled.div.attrs(
  ({ useBorder, useInverseColors }) => ({
    borderWidth: (useInverseColors && 2) || (useBorder && 1) || 0,
  })
)`
  height: ${props => props.size}px;
  width: ${props => props.size}px;

  // font size is scaled based on the size of div and length of text
  font-size: ${({ size, textLength, defaultSize, useScaling, borderWidth }) =>
    // integers used with `textLength` are font size in with default size
    Math.round(
      ((size - (useScaling ? borderWidth : 0)) * (textLength > 2 ? 14 : 19)) /
        defaultSize
    )}px;

  font-weight: ${props => (props.useInverseColors ? 600 : 400)};
  background-color: ${props => props.routeColor};
  color: ${({ useInverseColors, theme }) =>
    useInverseColors ? theme.routeStopStrokeColor : theme.routeStopFillColor};
  border-radius: 50%;
  border-color: ${({ useInverseColors, theme }) =>
    useInverseColors
      ? theme.routeStopStrokeColor
      : theme.routeDetailBadgeBorder};
  border-style: solid;
  border-width: ${props => props.borderWidth}px;
  box-sizing: ${props => (props.useScaling ? 'border-box' : 'content-box')};

  user-select: none;
  cursor: default;

  &,
  & div,
  & span {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
  }
`;

export default RouteBadge;
